import { selector } from 'recoil';
import { countOrderProductsByType } from '../../helpers/product-count-by-type.js';
import orderDetailsState from './order-details-state.js';
const orderDetailsProductCountState = selector({
    key: 'orderDetailsProductCount',
    get: ({ get }) => {
        const orderDetails = get(orderDetailsState.response);
        if (orderDetails) {
            return countOrderProductsByType({
                order: orderDetails.Result,
            });
        }
    },
});
export default orderDetailsProductCountState;
//# sourceMappingURL=order-details-product-count-state.js.map